import { useLocation } from 'react-router-dom';
import { Box, Button, Grid, Typography } from '@mui/material';
import React, { useCallback, useContext, useState } from 'react';
import { useSnackbar } from 'notistack';

import { FormContainer, PageContainer } from '../../components/Containers';
import SwitchToggle from '../../components/SwitchToggle';
import { UserContext } from '../../Context/UserContext/UserContextProvider';
import { LoggingContext } from '../../Context/LoggingContext/LoggingContext';

function SettingsPage() {
  const location = useLocation();
  const { enqueueSnackbar } = useSnackbar();
  const { addLog } = useContext(LoggingContext);
  const { userDetailsState, dispatchUserDetailsState } = useContext(UserContext);
  const [localUnitcmState, setLocalUnitcmState] = useState<1 | 2.57>(userDetailsState.unitcm);

  function handleSaveChangesFunction(event: React.SyntheticEvent) {
    addLog('handle saved changes fired', location.pathname);
    event.preventDefault();
    dispatchUserDetailsState({
      type: 'update settings',
      payload: { unitcm: localUnitcmState },
    });
    enqueueSnackbar(`Settings saved`, { variant: 'success' });
  }
  const handleSaveChanges = useCallback(handleSaveChangesFunction, [localUnitcmState]);

  return (
    <PageContainer>
      <Typography variant='h3' sx={{ textAlign: 'center' }}>
        Settings
      </Typography>
      <FormContainer onSubmit={handleSaveChanges}>
        <Grid item xs={12}>
          <SwitchToggle
            value={localUnitcmState}
            updateParentValue={setLocalUnitcmState}
            inputLabels={['cm', 'inches']}
            legend='Preferred units'
            labelPlacement='bottom'
          />
        </Grid>
        <Box
          sx={{
            width: '100%',
            marginTop: '8px',
            display: 'grid',
            gridTemplateRows: '1fr 1fr 1fr',
            justifyItems: 'center',
            '& button': { width: '300px' },
            gap: '8px 0px',
          }}
        >
          {' '}
          <Button variant='contained' size='small' type='submit'>
            Save Changes
          </Button>
        </Box>
      </FormContainer>
    </PageContainer>
  );
}

export default SettingsPage;
